import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const VerificationTooltip = ({ content }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        className="w-5 h-5 rounded-full bg-[var(--color-muted)] flex items-center justify-center hover:bg-[var(--color-primary)]/20 transition-colors"
      >
        <Icon name="Info" size={12} color="var(--color-muted-foreground)" />
      </button>
      {isVisible && (
        <div className="absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-3 bg-[var(--color-popover)] border border-[var(--color-border)] rounded-xl shadow-xl">
          <p className="text-xs text-[var(--color-popover-foreground)] leading-relaxed">{content}</p>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
            <div className="w-2 h-2 bg-[var(--color-popover)] border-r border-b border-[var(--color-border)] transform rotate-45" />
          </div>
        </div>
      )}
    </div>
  );
};

export default VerificationTooltip;
